const en = {
    header: {
        title: 'Poker Chip Calculator',
        intro: 'Fill in the input fields to generate Tournament payouts/ Chip Distribution and Blind structure.',
        downloadButton: 'Download results'
    },
    pdf: {
        downloadButton: 'Download results',
        userSelection: {
            sectionTitle: 'Your selection',
            table: {
                headers: {
                    key: 'Selection',
                    value: 'Value'
                }
            }
        },
        tournamentPayouts: {
            table: {
                headers: {
                    key: 'No.',
                    value: 'Payout'
                }
            }
        },
        chipDistribution: {
            table: {
                headers: {
                    color: 'Chip Color',
                    value: 'Chip Value',
                    each: 'Each Player',
                    quantity: 'Total Chips',
                }
            }
        }
    },
    form: {
        btn: {
            calculate: 'Calculate',
            reset: 'Reset',
        },
        fields: {
            requiredError: 'Field required',
            payoutStructure: {
                label: 'Payout Structure',
                optionLabels: {
                    regular: 'Regular',
                    winner: 'Winner Takes all',
                    top3: 'Top 3'
                }
            },
            buyIn: {
                label: 'Buy-In',
                errorTexts: {
                    rangeUnderflow: 'Buy in value must be greater or equal 0'
                }
            },
            numberOfPlayers: {
                label: '# of Players',
                errorTexts: {
                    rangeUnderflow: 'Amount of players must be greater than 0',
                    rangeOverflow: 'Amount of players must be less than 60'
                }
            },
            tournamentType: {
                label: 'Tournament Type',
                optionLabels: {
                    regular: 'Regular',
                    turbo: 'Turbo',
                    superturbo: 'Super Turbo'
                }
            },
            tournamentLength: {
                label: 'Tournament Length (hours)',
            },
            blindLevel: {
                label: 'Blind Level (mins)'
            },
            numberOfChips: {
                label: 'Starting Chip Value',
            },
        }
    },
    results: {
        tournamentPayouts: {
            cardTitle: 'Tournament Payouts',
            prizePool: 'Prizepool',
            listCaption: 'Payout',
        },
        chipDistribution: {
            cardTitle: 'Chip Distribution',
            table: {
                caption: 'Starting Chips',
                headers: {
                    chip: 'Chip',
                    color: 'Chip Color',
                    value: 'Chip Value',
                    each: '# Chips / Player',
                    quantity: 'Total Required',
                }
            }
        },
        blindStructure: {
            cardTitle: 'Blind Structure',
            table: {
                caption: 'Blind Levels',
                headers: {
                    smallBlind: 'Small Blind',
                    bigBlind: 'Big Blind',
                    time: 'Next Level',
                }
            }
        }
    },
};

export default en;
